(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializedCards = new WeakSet();
  const changedSelections = new Map();
  const generalEnquiryKey = '__bn_general_enquiry__';

  const initializeInterestForms = (root = document) => {
    const cards = root instanceof Element && root.matches('[data-bn-contact-interest]')
      ? [root]
      : root.querySelectorAll('[data-bn-contact-interest]');

    cards.forEach((card) => {
      if (initializedCards.has(card)) return;
      const select = card.querySelector('[data-bn-product-select]');
      const backLink = card.querySelector('[data-bn-product-back]');
      if (!select || !backLink || !select.form) return;
      initializedCards.add(card);

    const options = Array.from(select.options);
    const productKeys = new Set(options.map(option => option.dataset.productKey).filter(Boolean));
      const formKey = select.form.id;
      const submissionStorageKey = `bn-contact-interest:${formKey}`;
      const findProduct = (key) => productKeys.has(key)
        ? options.find((option) => option.dataset.productKey === key)
        : undefined;
      let submittedOption;
      if (card.querySelector('.bn-contact__success')) {
        try {
          window.sessionStorage.removeItem(submissionStorageKey);
        } catch {}
      } else if (card.querySelector('.bn-contact__errors')) {
        try {
          const submittedKey = window.sessionStorage.getItem(submissionStorageKey);
          window.sessionStorage.removeItem(submissionStorageKey);
          submittedOption = submittedKey === generalEnquiryKey
            ? options.find((option) => option.dataset.productKey === '')
            : findProduct(submittedKey);
        } catch {}
      }
      const updateBackLink = () => {
        const option = select.selectedOptions[0];
        const hasProduct = option && productKeys.has(option.dataset.productKey);
        backLink.hidden = !hasProduct;
        if (hasProduct) {
          backLink.setAttribute('href', option.dataset.productUrl);
          backLink.textContent = option.dataset.returnLabel;
        } else {
          backLink.removeAttribute('href');
          backLink.textContent = '';
        }
      };

      if (changedSelections.has(formKey)) {
        const rememberedKey = changedSelections.get(formKey);
        const rememberedOption = findProduct(rememberedKey)
          || options.find((option) => option.dataset.productKey === '');
        if (rememberedOption) rememberedOption.selected = true;
      } else if (submittedOption) {
        submittedOption.selected = true;
        changedSelections.set(formKey, submittedOption.dataset.productKey);
      } else {
        const requestedKey = new URLSearchParams(window.location.search).get('product');
        const requestedOption = findProduct(requestedKey);
        if (requestedOption) requestedOption.selected = true;
      }

      updateBackLink();
      select.addEventListener('change', () => {
        changedSelections.set(formKey, select.selectedOptions[0]?.dataset.productKey || '');
        updateBackLink();
      });
      select.form.addEventListener('submit', () => {
        const selectedKey = select.selectedOptions[0]?.dataset.productKey;
        const submissionKey = productKeys.has(selectedKey)
          ? selectedKey
          : selectedKey === '' ? generalEnquiryKey : undefined;
        if (!submissionKey) return;
        try {
          window.sessionStorage.setItem(submissionStorageKey, submissionKey);
        } catch {}
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeInterestForms(), { once: true });
  } else {
    initializeInterestForms();
  }
  document.addEventListener('shopify:section:load', (event) => initializeInterestForms(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
